import axios from 'axios';
import { getHeaders } from '../utils/http';

const baseUrl = process.env.BASE_SERVER_ADDRESS;

export const AllChallengesQuery = async () => {
  return await axios.get(`${baseUrl}/challenge/All`, getHeaders());
};
